module.exports = __webpack_public_path__ + "static/media/google.76da3f52.png";